import { css } from 'emotion';
import { AvatarSize } from '.';
import { colors } from '@joykit';
import { ColorTypes, getColorByType } from '@joykit/variables/colors';

export namespace styles {
  export const container = (url: string | null | undefined, size: AvatarSize, backgroundColor?: ColorTypes) => {
    return css(
      {
        backgroundImage: url ? `url("${url}")` : undefined,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        borderRadius: '50%',
        backgroundColor: backgroundColor ? getColorByType(backgroundColor) : colors.light
      },
      typeof size === 'number'
        ? {
            width: size,
            height: size
          }
        : {
            // TODO: Fix
            paddingTop: '100%'
          }
    );
  };
}
